/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DocumentVendor } from '../models/DocumentVendor';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DocumentsRepository {
  /**
   * Post Webhook
   * Provide a webhook target for pandadoc document status change events.
   * @returns any Successful Response
   * @throws ApiError
   */
  public static documentsPostWebhook({
    vendor,
    signature,
  }: {
    vendor: DocumentVendor,
    signature: string,
  }): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/noauth/documents/{vendor}/webhooks',
      path: {
        'vendor': vendor,
      },
      query: {
        'signature': signature,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
